import views from '@/views/';

export default [
  {
    component: views.chainManageStatistics.chainManage,
    label: '诊所经营情况',
    path: 'chainManage',
    name: 'chainManage',
  },
  {
    component: views.chainManageStatistics.chainDrugSale,
    label: '诊所用药统计',
    path: 'chainDrugSale',
    name: 'chainDrugSale',
  },
];
